/**
 * @Author: v_jppjpeng
 * @Date: 2022-09-22 16:14:04
 * @Explain: 模板管理
 */

export default {
  // 模板管理
  'TEMPLATE.MANAGE.LIST.TITLE': '模板列表',
  'TEMPLATE.MANAGE.NO.TEMPLATE': '没有模板',
  'TEMPLATE.MANAGE.ADD.TEMPLATE': '创建营销模板',
  'TEMPLATE.MANAGE.ADD.TRANS.TEMPLATE': '创建事务模板',
  'TEMPLATE.MANAGE.ADD.MISSING.VARIABLE': '含有未创建的资源码',
  'TEMPLATE.MANAGE.ADD.MISSING.VARIABLE.DES': '含有未创建的资源码/联系人字段',
  'TEMPLATE.MANAGE.UN.ACTIVE.FORM': '含有未激活的表单',
  'TEMPLATE.MANAGE.ADD.MISSING.UNSUBSCRIBED': '未添加取消订阅链接',
  'TEMPLATE.MANAGE.CREATE.FIRST.TEMPLATE': '新建第一个模板',
  'TEMPLATE.MANAGE.TEMPLATE.LANGUAGE': '模板语言',
  'TEMPLATE.MANAGE.PLEASE.SELECT.TEMPLATE.LANGUAGE.LABEL': '语言',
  'TEMPLATE.MANAGE.PLEASE.SELECT.TEMPLATE.LANGUAGE.LABEL.DES': '为模板选择语种',
  'TEMPLATE.MANAGE.PLEASE.SELECT.TEMPLATE.LANGUAGE.LABEL.DES.PHD': '选择语种',
  'TEMPLATE.MANAGE.PLEASE.SELECT.TEMPLATE.LANGUAGE': '请选择模板语言',
  'TEMPLATE.MANAGE.TEMPLATE.SUBSCRIBE.STATUS': '取消订阅 & 设置偏好',
  'TEMPLATE.MANAGE.PLEASE.SELECT.SUBSCRIBESTATUS': '请选择',
  'TEMPLATE.MANAGE.TEMPLATE.SUBSCRIBETIP1': '去',
  'TEMPLATE.MANAGE.TEMPLATE.SUBSCRIBETIP2': ' 偏好设置 ',
  'TEMPLATE.MANAGE.EDITOR': '编辑人',
  'TEMPLATE.MANAGE.PLACEHOLDER': '资源码/联系人字段',
  'TEMPLATE.MANAGE.MARKET.UNSUBSCRIBE': '取消订阅',
  'TEMPLATE.MANAGE.LAST.SAVED': '上次保存时间',
  'TEMPLATE.MANAGE.VIEW.PLACEHOLDERS': '查看资源码',
  'TEMPLATE.MANAGE.EXPORT.HTML.FILE': '导出html文件',
  'TEMPLATE.MANAGE.DIALOG.EXPORT.HTML.FILE.TITLE': '请选择要导出的模板语言',
  'TEMPLATE.MANAGE.DIALOG.EXPORT.HTML.FILE.CONFIRM': '确认导出',
  'TEMPLATE.MANAGE.MARKET.TEMPLATE.PREVIEW': '邮件预览',

  'TEMPLATE.MANAGE.IS.DEL.TEMP': '确定删除营销邮件模板?',
  'TEMPLATE.MANAGE.IS.DEL.TRANS.TEMP': '确定删除事务型邮件模板?',
  'TEMPLATE.MANAGE.DELETE.DES':
    '删除 <span class="delete-dialog-mark">{name}</span> 后，模板信息不可恢复.',
  'TEMPLATE.MANAGE.DELETE.TRANS.DES':
    '删除 <span class="delete-dialog-mark">{name}</span> 后，模板信息不可恢复。且已使用此模板的线上服务将会收到接口返回错误。',
  'TEMPLATE.MANAGE.DELETE.CONFIRM': '输入 <b>删除</b> 确认此操作',
  'TEMPLATE.MANAGE.DELETE.CONFIRM.ERROR': '输入 删除 确认此操作',
  'TEMPLATE.MANAGE.DELETE.CONFIRM.INPUT': '删除',

  'TEMPLATE.MANAGE.IS.ROLLBACK.TEMP': '撤回发布',
  'TEMPLATE.MANAGE.IS.ROLLBACK.TEMP.SUCCESS': '撤回发布成功',
  'TEMPLATE.MANAGE.ROLLBACK.DES':
    '操作完成后，它将恢复到以前的发布版本，当前联机版本将恢复到草稿状态。',
  'TEMPLATE.MANAGE.TIP.INPUT.PHD': '在此输入',
  'TEMPLATE.MANAGE.ROLLBACK.TRANS.DES': '',
  'TEMPLATE.MANAGE.ROLLBACK.CONFIRM': '输入 <b>撤回</b> 确认此操作',
  'TEMPLATE.MANAGE.ROLLBACK.CONFIRM.ERROR': '输入 撤回 确认此操作',
  'TEMPLATE.MANAGE.ROLLBACK.CONFIRM.INPUT': '撤回',

  'TEMPLATE.MANAGE.ADD.HTML.TEMPLATE.MARKET': '创建营销模板',
  'TEMPLATE.MANAGE.ADD.TEMPLATE.MARKET': '创建模板',
  'TEMPLATE.MANAGE.PLEASE.ENTER.A.TEMPLATE.NAME': '请输入模板名称，上限50字符',
  'TEMPLATE.MANAGE.NEW.TEMPLATE.METHOD': '新建模板方式',
  'TEMPLATE.MANAGE.UPLOAD.HTML.FILE': '上传HTML文件',
  'TEMPLATE.MANAGE.RICH.TEXT': '富文本编辑器',
  'TEMPLATE.MANAGE.PLEASE.UPLOAD.HTML.FILE': '请上传HTML文件',
  'TEMPLATE.MANAGE.PASTE.HTML.CODE': '粘贴HTML代码',
  'TEMPLATE.MANAGE.MULTI.MEDIA.EDITOR': '设计模板布局',
  'TEMPLATE.MANAGE.TEMPLATE.PREVIEW': '模板预览',
  'TEMPLATE.MANAGE.EDIT.CODE': '编辑代码',
  'TEMPLATE.MANAGE.EDIT.CODE.TIPS':
    '提示：使用{paramName}表示模板中的变量，其中变量名只支持英文字母、数字、短横线、下划线，且严格区分大小写',
  'TEMPLATE.MANAGE.CONTENT.ERROR': '内容有误，请联系技术人员排查问题',
  'TEMPLATE.MANAGE.PLEASE.FILL.IN.THE.CODE.CONTENT': '请填写内容',
  'TEMPLATE.MANAGE.FOLDER': '文件夹',
  'TEMPLATE.MANAGE.NAME': '请输入模板名称',
  'TEMPLATE.MANAGE.DELETE.FOLDER0': '确定删除此文件夹吗？',
  'TEMPLATE.MANAGE.DELETE.FOLDER1': '删除后文件夹将无法恢复，请谨慎操作。',
  'TEMPLATE.MANAGE.MOVETO': '移动到',
  'TEMPLATE.MANAGE.ADD.FOLDER': '新建文件夹',
  'TEMPLATE.MANAGE.MOVE': '移动模板',
  'TEMPLATE.MANAGE.SELECT': '请选择文件夹',
  'TEMPLATE.CANCEL.SUBSCRIPTION': '支持取消订阅',
  'TEMPLATE.CANCEL.SUBSCRIPTION.DES':
    '在打开的邮件中，我们会自动在页脚处添加一个取消订阅按钮。一旦用户点击该按钮取消订阅，他们的订阅状态将立即在【用户管理】中得到更新，并且在之后SmartLink发送的邮件中，已取消订阅的用户将自动被剔除。',
  'TEMPLATE.MANAGE.MOVE.SUCCESS': '移动成功',
  'TEMPLATE.MANAGE.UNSUBSCRIBE': '取消订阅此邮件',
  'TEMPLATE.MANAGE.ENTER.NAME': '请输入文件夹名称',
  'TEMPLATE.MANAGE.CHECK.NAME': '文件夹名称不能为空',
  'TEMPLATE.MANAGE.EDITING': '编辑中',
  'TEMPLATE.MANAGE.LINK.EXIST': '已添加',
  'TEMPLATE.MANAGE.LINK.NOT.EXIST': '未添加',
  'TEMPLATE.MANAGE.PND.INCLUDE.NOT.ADD': '包含未创建的资源码',
  'TEMPLATE.MANAGE.ACTIVITY': '模板在正在进行的活动中使用',
  'TEMPLATE.MANAGE.EDITING.NAME': '{name}正在编辑...',
  'TEMPLATE.MANAGE.EDITING.TIPS': '不允许多人同时编辑',
  'TEMPLATE.MANAGE.OTHERS.EDITING.TIPS': '当前有其他人正在编辑',
  'TEMPLATE.MANAGE.SEND.CONTENT.ERROR': '获取邮件内容有误',
  'TEMPLATE.MANAGE.SEND.ERROR': '发送失败',
  'TEMPLATE.MANAGE.MULTILINGUAL.EDIT': '编辑多语言文本',
  'TEMPLATE.MANAGE.MULTILINGUAL.SYNC': '同步',
  'TEMPLATE.MANAGE.MULTILINGUAL.INIT.LANGUAGE': '初始语种',

  // 验证变量
  'TEMPLATE.MANAGE.VERIFY.VAR.TITLE': '资源码',
  'TEMPLATE.MANAGE.VERIFY.CONTACT.TITLE': '个人信息',
  'TEMPLATE.MANAGE.VERIFY.CONTACT.NAME': '联系人字段',
  'TEMPLATE.MANAGE.VERIFY.VAR.NAME': '资源码',
  'TEMPLATE.MANAGE.VERIFY.VAR.TYPE': '类型',
  'TEMPLATE.MANAGE.VERIFY.VAR.ASSIGNMENT.SITUATION': '可用码数量',
  'TEMPLATE.MANAGE.CONTACT.COLUMN': '默认值设置',
  'TEMPLATE.MANAGE.VERIFY.VAR.NOT.CREATE': '未创建',
  'TEMPLATE.MANAGE.VERIFY.VAR.PLACEHOLDER.NAME.REG':
    '以下资源码（{name}）有误，仅支持英文字母、数字、下划线',

  // 邮件模板——偏好设置入口
  'TEMPLATE.MANAGE.PREFERENCE.NONE': '不添加',
  'TEMPLATE.MANAGE.PREFERENCE.UNSUBSCRIBE': '取消订阅',
  'TEMPLATE.MANAGE.PREFERENCE.UNSUBSCRIBEANDSET': '设置偏好 & 取消订阅',

  // 2.8.0 列表 - 文件夹
  'TEMPLATE.MANAGE.FOLDER.LABEL': '文件夹',
  'TEMPLATE.MANAGE.FOLDER.ADD': '新增文件夹',
  'TEMPLATE.MANAGE.FOLDER.EDIT': '编辑文件夹',
  'TEMPLATE.MANAGE.FOLDER.DONE': '完成',
  'TEMPLATE.MANAGE.FOLDER.NAME.UNGROUPED': '未分组',
  'TEMPLATE.MANAGE.FOLDER.NAME.UNGROUPED1': '未分类',
  'TEMPLATE.MANAGE.FOLDER.NAME.BLANK.SPACE': '请删除名称前后的空格',

  // 空提示
  'TEMPLATE.MANAGE.ADD.TEMPLATE.TITLE': '创建第一个邮件模板',
  'TEMPLATE.MANAGE.ADD.TEMPLATE.DES': '创建模板后，可以在活动中使用',
  'TEMPLATE.MANAGE.ADD.TEMPLATE.TRANS.DES':
    '<p style="padding-bottom: 10px">事务型邮件通常用于传递关键信息，而不是促销内容。</p>' +
    '通常为自动发送的电子邮件消息，玩家在网站或应用程序上执行的特定操作或事件触发。如：购买确认、密码重置链接或帐户激活电子邮件。',

  // 创建模板
  'TEMPLATE.MANAGE.ADD.TEMPLATE.MAIL': '拖拽式邮件模板编辑器',
  'TEMPLATE.MANAGE.ADD.TEMPLATE.MAIL.MJML': '拖拽式邮件模板编辑器',
  'TEMPLATE.MANAGE.ADD.TEMPLATE.HTML': '导入HTML文件',
  'TEMPLATE.MANAGE.ADD.TEMPLATE.UPLOAD': '导入HTML文件',
  'TEMPLATE.MANAGE.ADD.TEMPLATE.MJML': '导入MJML文件',
  'TEMPLATE.MANAGE.ADD.TEMPLATE.MARKDOWN': '富文本编辑器',
  'TEMPLATE.MANAGE.ADD.TEMPLATE.DETAIL': '详情',
  'TEMPLATE.MANAGE.ADD.TEMPLATE.MAILTIP':
    '可创建邮件格式内容模板，采用响应式设计，适用于大多数流行的电子邮件客户端，甚至包括 Outlook 和 gmail。<a href="{link}" target="_blank">查看详情</a>',
  'TEMPLATE.MANAGE.ADD.TEMPLATE.MAILTIP.LINK':
    '/zh/function-guide/manage-template-template-editor/',
  'TEMPLATE.MANAGE.ADD.TEMPLATE.HTMLTIP': '导入文件需要使用UTF-8编码',
  'TEMPLATE.MANAGE.ADD.TEMPLATE.MARKDOWNTIP':
    '请使用富文本编辑电子邮件，不对内容进行复杂的排版，以保持简单和个性化。',
  'TEMPLATE.MANAGE.TEMPLATE.NAME': '模板名称',
  'TEMPLATE.MANAGE.TEMPLATE.NAME.PLACEHOLDER': '输入模板名称',
  'TEMPLATE.MANAGE.TEMPLATE.GROUP': '放入文件夹',
  'TEMPLATE.MANAGE.TEMPLATE.GROUP.NAME': '文件夹名称',
  'TEMPLATE.MANAGE.TEMPLATE.GROUPPREFIX': '文件夹',
  'TEMPLATE.MANAGE.TEMPLATE.UPLOAD.TITLE':
    '点击选择本地文件，或将文件拖拽到此处',
  'TEMPLATE.MANAGE.TEMPLATE.UPLOAD.DESC':
    '为确保兼容性，请参考 <a href="{url}" style="color: #00a386;text-decoration: none;" target="_blank">HTML模板制作指引</a>来制作您的邮件模板。',
  'TEMPLATE.MANAGE.TEMPLATE.UPLOAD.DESC.HTML.LABEL': 'HTML',
  'TEMPLATE.MANAGE.TEMPLATE.UPLOAD.DESC.HTML.CONTENT':
    '.html 文件需采用utf-8编码格式，或gbk编码格式\n' +
    '代码中的文本内容不包含乱码',
  'TEMPLATE.MANAGE.TEMPLATE.UPLOAD.DESC.MJML.LABEL': 'MJML',
  'TEMPLATE.MANAGE.TEMPLATE.UPLOAD.DESC.MJML.CONTENT':
    '.mjml文件，适用于大多数流行的电子邮件客户端，甚至包括 Outlook 和 gmail。 可由运营同学可在Smartlink的拖拽式邮件模板编辑器\n' +
    '中创建，或由开发人员在IDE工具或第三方支持mjml的平台创建；',
  'TEMPLATE.MANAGE.TEMPLATE.GROUPTIP':
    '文件夹可以帮您对模板分组，可在列表页创建文件夹。',
  'TEMPLATE.MANAGE.ADD.CONFIRM': '继续',
  'TEMPLATE.MANAGE.COPY.SUFFIX': '副本',

  // dialog mail placeholder
  'TEMPLATE.MANAGE.MAIL.PLACEHOLDER.TITLE': '选择资源码',
  'TEMPLATE.MANAGE.MAIL.PLACEHOLDER.FIXED.TITLE': '固定值资源码',
  'TEMPLATE.MANAGE.MAIL.PLACEHOLDER.FIXED.DYNAMIC': '动态值资源码',
  'TEMPLATE.MANAGE.MAIL.PLACEHOLDER.SEARCH.PLACEHOLDER': '搜索',
  'TEMPLATE.MANAGE.MAIL.PLACEHOLDER.SEARCH.EMPTY': '暂无数据',
  'TEMPLATE.MANAGE.MAIL.PLACEHOLDER.ADD.BTN.TITLE': '新增资源码',

  // dialog mail link
  'TEMPLATE.MANAGE.MAIL.LINK.DIALOG.TITLE': '链接',
  'TEMPLATE.MANAGE.MAIL.LINK.DIALOG.DISPALYTEXT': '显示文本',
  'TEMPLATE.MANAGE.MAIL.LINK.DIALOG.LINKTYPE': '链接类型',
  'TEMPLATE.MANAGE.MAIL.LINK.DIALOG.LINKTARGET': '打开方式',
  'TEMPLATE.MANAGE.MAIL.LINK.DIALOG.LINKTARGET.PLACEHOLDER': '<not set>',
  'TEMPLATE.MANAGE.MAIL.LINK.DIALOG.URL': 'URL类型',
  'TEMPLATE.MANAGE.MAIL.LINK.DIALOG.CUSTOM': '自定义',
  'TEMPLATE.MANAGE.MAIL.LINK.DIALOG.UNSUBSCRIBE': '取消订阅',
  'TEMPLATE.MANAGE.MAIL.LINK.DIALOG.UPDATEPRFERENCE': '更新偏好',
  'TEMPLATE.MANAGE.MAIL.LINK.DIALOG.VIEW.EMAIL.BROWSER': '在浏览器中查看',
  'TEMPLATE.MANAGE.MAIL.LINK.DIALOG.OPT.CONFIRM': '确认订阅',
  'TEMPLATE.MANAGE.MAIL.LINK.DIALOG.OK': '确定',

  // unsubscribe
  'TEMPLATE.MANAGE.MAIL.UNSUBSCRIBE': 'Unsubscribe',
  'TEMPLATE.MANAGE.MAIL.UPDATE.PREFERENCE': 'Update preferences',
  'TEMPLATE.MANAGE.MAIL.UPDATE.VIEW': 'View in browser',
  'TEMPLATE.MANAGE.MAIL.UPDATE.OPT': 'Confirms subscription',

  // check placeholder and url dialog
  'TEMPLATE.MANAGE.MAIL.REVIEW.DIALOG.TITLE': '检查联系人字段、资源码和链接',
  'TEMPLATE.MANAGE.MAIL.VERIFY.DIALOG.TITLE': '保存前请确认',
  'TEMPLATE.MANAGE.MAIL.REVIEW.DIALOG.TITLE1':
    '请确认联系人字段/资源码是否已创建或赋值',
  'TEMPLATE.MANAGE.MAIL.REVIEW.DIALOG.TITLE2':
    '请确认模板内链接&为链接添加标记',
  'TEMPLATE.MANAGE.MAIL.REVIEW.DIALOG.DETECTED': '检测到系统内存在',
  'TEMPLATE.MANAGE.MAIL.REVIEW.DIALOG.DETECTED2':
    '如需插入联系人字段或资源码，请到模板中重新插入正确的联系人字段或资源码。',
  'TEMPLATE.MANAGE.MAIL.REVIEW.DIALOG.PLACEHOLDERS.TIP':
    '检查链接和相应展示文本',
  'TEMPLATE.MANAGE.MAIL.REVIEW.DIALOG.LINKS.TIP': '检查链接和相应展示文本',
  'TEMPLATE.MANAGE.MAIL.REVIEW.DIALOG.LINKS.COLUMN.URL': '链接',
  'TEMPLATE.MANAGE.MAIL.REVIEW.DIALOG.LINKS.COLUMN.TEXT': '显示文字',
  'TEMPLATE.MANAGE.MAIL.REVIEW.DIALOG.LINKS.COLUMN.IMG': '图片',
  'TEMPLATE.MANAGE.MAIL.REVIEW.DIALOG.LINKS.COLUMN.NOTE': '标签',
  'TEMPLATE.MANAGE.MAIL.REVIEW.DIALOG.LINKS.COLUMN.NOTETIP':
    '设置备注可帮助您更好地区分不同的链接，您可以在活动报表的点击表现中看到它们',
  'TEMPLATE.MANAGE.MAIL.REVIEW.DIALOG.FORMS.TIP': '检查表单是否被激活',

  // mjml
  'TEMPLATE.MANAGE.MJML.DIALOG.IMPORT.ERROR': 'mjml格式错误',
  'TEMPLATE.MANAGE.MAIL.UPLOAD.TITLE': '上传和选择',
  'TEMPLATE.MANAGE.MAIL.UPLOAD.SUBTITLE': '上传',
  'TEMPLATE.MANAGE.MAIL.UPLOAD.LOADING.TEXT': '加载中...',
  'TEMPLATE.MANAGE.MAIL.UPLOAD.SUBTITLE.LIMIT.TYPE': '请上传图片',
  'TEMPLATE.MANAGE.MAIL.UPLOAD.SUBTITLE.LIMIT.SUPER': '内部账号无法上传',
  'TEMPLATE.MANAGE.MAIL.UPLOAD.SUBTITLE.LIMIT.SIZE': '限制 5MB',
  'TEMPLATE.MANAGE.MAIL.UPLOAD.DEL.TIP': '确认删除？',
  'TEMPLATE.MANAGE.MAIL.UPLOAD.DEL.CANCEL': '取消',
  'TEMPLATE.MANAGE.MAIL.UPLOAD.DEL.CONFIRM': '确认',
  'TEMPLATE.MANAGE.MAIL.UPLOAD.BEEN.DELETE': '图片已被删除',
  'TEMPLATE.MANAGE.MAIL.UPLOAD.COMPONENT.TIP':
    '<span style="font-weight: bold">拖拽文件到这' +
    ' 或 ' +
    '<span  class="color-primary">点击上传</span></span>',
  'TEMPLATE.MANAGE.MAIL.UPLOAD.COMPONENT.TIP2':
    '<span style="color: #666666;font-size: 14px;">支持导入<span  class="color-primary">.jpg, .jpeg, .png, .gif, .bmp, .tif, .tiff</span>格式图片</span>',
  'TEMPLATE.MANAGE.MAIL.UPLOAD.COMPONENT.TIP2.1':
    '<span style="color: #666666;font-size: 14px;">支持导入<span  class="color-primary">.jpg, .jpeg, .png</span>格式图片</span>',
  'TEMPLATE.MANAGE.MAIL.UPLOAD.COMPONENT.TIP3':
    '<span style="color: #666666;font-size: 14px;">请导入<span class="color-primary">0~5MB</span> 大小图片</span>',
  'TEMPLATE.MANAGE.MAIL.UPLOAD.SUBTITLE.IMAGE.URL': '图片路径',
  'TEMPLATE.MANAGE.MAIL.UPLOAD.SUBTITLE.IMAGE.URL.PLACEHOLDER':
    'http://path/to/the/image',
  'TEMPLATE.MANAGE.MAIL.UPLOAD.RIGHT.TIP': '选择图片',
  'TEMPLATE.MANAGE.MAIL.UPLOAD.ASSETS.EMPTY.TIP':
    '当前没有图片.<br>' + '请上传或添加',
  'TEMPLATE.MANAGE.MAIL.UPLOAD.ASSETS.CONFIRM.EMPTY': '请选择图片',
  'TEMPLATE.MANAGE.MAIL.UPLOAD.INPUT.URL.FAIL': '图片链接无效',
  'TEMPLATE.MANAGE.EDITOR.SAVE.TIP': '保存并退出',
  'TEMPLATE.MANAGE.EDITOR.SAVE.TRANS.PUBLIC.TIP': '保存',
  'TEMPLATE.MANAGE.EDITOR.SAVE.DISABLED.SAVED.BTN':
    '主题和预览文本未变更无需重新保存',
  'TEMPLATE.MANAGE.EDITOR.SAVE.SAVED.SUCCESS': '主题和预览文本已保存',
  'TEMPLATE.MANAGE.EDITOR.SAVE.SAVED.DIALOG.HEADER.TITLE':
    '是否保存主题和预览文本？',
  'TEMPLATE.MANAGE.EDITOR.SAVE.SAVED.DIALOG.SAVED': '保存',
  'TEMPLATE.MANAGE.EDITOR.SAVE.SAVED.DIALOG.DONT.SAVED': '不保存',
  'TEMPLATE.MANAGE.EDITOR.SAVE.TRANS.TIP': '保存草稿',
  'TEMPLATE.MANAGE.EDITOR.PUBLISH.TIP': '发布',

  'TEMPLATE.MANAGE.EDITOR.EDIT.LOADING': ' <span class="editing">编辑中</span>',
  'TEMPLATE.MANAGE.EDITOR.SAVE.LOADING': ' <span class="saving">保存中</span>',
  'TEMPLATE.MANAGE.EDITOR.SAVE.LOADING.PROCESS': '自动保存中',
  'TEMPLATE.MANAGE.EDITOR.SAVE.FINISH': '<span class="saved">已保存</span>',
  'TEMPLATE.MANAGE.EDITOR.SAVE.ERROR': '<span class="saved">保存失败</span>',

  //   mjml - options
  'TEMPLATE.MANAGE.MJML.CONTENT': '内容',
  'TEMPLATE.MANAGE.MJML.IMG.SOURCE.ERROR': '不支持编辑器外部拖入图片',
  'TEMPLATE.MANAGE.MJML.ROW': '行',
  'TEMPLATE.MANAGE.MJML.BODY': '画布',
  'TEMPLATE.MANAGE.MJML.URL.RESELECT.TIP': '文字识别失败，请重试',
  'TEMPLATE.MANAGE.MJML.URL.RESELECT.LI.TEXT': '限制列表文本跨行添加链接',
  'TEMPLATE.MANAGE.MJML.SET': '设置',
  'TEMPLATE.MANAGE.MJML.PREVIEW': '退出预览',
  'TEMPLATE.MANAGE.MJML.LOAD': '加载中',
  'TEMPLATE.MANAGE.MJML.EDIT.SAVE.TIP.TITLE': 'Save changes reminder',
  'TEMPLATE.MANAGE.MJML.EDIT.SAVE.TIP':
    '<span class="tip-title">保存提醒</span><br/>' +
    '<span class="tip-content">超过30分钟未操作，再闲置10分钟后，其他用户可以开始编辑。</span>',
  'TEMPLATE.MANAGE.MJML.EDIT.TIMEOUT.AND.BEING.EDITED.TIP':
    '<span class="tip-title">保存提醒</span><br/>' +
    '<span class="tip-content">超过40分钟未编辑，模板已被其他用户编辑。</span>',
  'TEMPLATE.MANAGE.MJML.EDIT.TIMEOUT.TIP':
    '<span class="tip-title">保存提醒</span><br/>' +
    '<span class="tip-content">超过40分钟未编辑</span>',
  'TEMPLATE.MANAGE.LIST.TIMEOUT.TIP':
    '<span style="text-indent: 28px;display: inline-block">超过40分钟未操作，模板“{timeoutTemplateName}”已被其他用户编辑</span>',
  'TEMPLATE.MANAGE.MJML.EDIT.NETWORK.TIP':
    '<span class="tip-title">网络中断</span><br/>' +
    '<span class="tip-content">网络中断，模板内容未保存，允许其他人重新编辑此模板</span>',
  'TEMPLATE.MANAGE.LOCK.TIP': '模板已被其他用户编辑',
  'TEMPLATE.MANAGE.NO.PERMISSION.TIP': '操作无权限！',
  'TEMPLATE.MANAGE.NO.ID': '无效的模板id',
  'TEMPLATE.MANAGE.NO.PUB.PARAMS': '请填写 subject 和 sender',
  'TEMPLATE.MANAGE.content.XSS.TIP':
    '保存失败，请尝试将<span style="color:red">{msg}</span>删除后重新保存',

  // html monaco editor
  'TEMPLATE.MANAGE.HTML.EDITOR.CODE.TAB.TIP': '编辑HTML代码',
  'TEMPLATE.MANAGE.HTML.EDITOR.ADD.SUBJECT.PREVIEW': '主题',
  'TEMPLATE.MANAGE.HTML.EDITOR.LINK.TAB.TIP': '编辑功能型链接',
  'TEMPLATE.MANAGE.HTML.EDITOR.SET.TAB.TIP': '设置',
  'TEMPLATE.MANAGE.HTML.EDITOR.LINK.TAB.TIP.CONTENT.TITLE':
    '添加方式选择（浏览器打开邮件暂时仅支持自定义样式）',
  'TEMPLATE.MANAGE.HTML.EDITOR.LINK.SELECT.TITLE': '直接插入默认样式',
  'TEMPLATE.MANAGE.HTML.EDITOR.LINK.SELECT.LABEL': '类型',
  'TEMPLATE.MANAGE.HTML.EDITOR.LINK.CUSTOM.TITLE': '自定义样式',
  'TEMPLATE.MANAGE.HTML.EDITOR.LINK.CUSTOM.SUBTITLE':
    '如果你需要定制链接样式，可复制代码块到文件中。',
  'TEMPLATE.MANAGE.HTML.EDITOR.LINK.CUSTOM.UNSUB.TIP': '1、 取消订阅',
  'TEMPLATE.MANAGE.HTML.EDITOR.LINK.CUSTOM.UPDATE.TIP': '2、 更新偏好',
  'TEMPLATE.MANAGE.HTML.EDITOR.LINK.CUSTOM.VIEW.TIP': '3、 浏览器中打开邮件',
  'TEMPLATE.MANAGE.HTML.EDITOR.LINK.CUSTOM.OPT.CONFIRM.TIP': '4、 确认订阅',

  'TEMPLATE.MANAGE.HTML.EDITOR.LINK.COPY.TIP': '复制',
  'TEMPLATE.MANAGE.HTML.EDITOR.SAVE.PREVIEW.TAB.TIP': '保存代码&预览',
  'TEMPLATE.MANAGE.HTML.EDITOR.SAVE.LINK.TAB.TIP': '确认',
  'TEMPLATE.MANAGE.HTML.EDITOR.COPY.SUCCESS': '复制成功',
  'TEMPLATE.MANAGE.HTML.EDITOR.LINK.SELECT.SAVE':
    '选择模板语言后可预览插入取消订阅/更新偏好的默认样式',

  // rich
  'TEMPLATE.MANAGE.RICH.PLACEHOLDER.TIP': '资源码',
  'TEMPLATE.MANAGE.RICH.IMG.TIP': '图片',
  'TEMPLATE.MANAGE.RICH.LINK.TIP': '链接',

  'TEMPLATE.MANAGE.TEMPLATE.UPDATE': '更新人',

  'TEMPLATE.MANAGE.TEMPLATE.RETURN.TIP': '确定是否保存修改内容? ',
  'TEMPLATE.MANAGE.TEMPLATE.RETURN.BODY.TIP':
    '选择不保存，您修改的内容将被删除且不可恢复。\n' +
    '选择保存，可保存新修改内容。',
  'TEMPLATE.MANAGE.TEMPLATE.RETURN.CANCEL': '不保存',
  'TEMPLATE.MANAGE.TEMPLATE.RETURN.CONFIRM': '保存',
  'TEMPLATE.MANAGE.TEMPLATE.PUBLISH.TIP': '确定发布事务型邮件模板?',
  'TEMPLATE.MANAGE.TEMPLATE.PUBLISH.CONTENT':
    '发布后，使用此模板的线上服务将会立刻更新至此模板数据。建议在发布前充分测试。',
  'TEMPLATE.MANAGE.TEMPLATE.PUBLISH.BOTTOM': '是否确认发布？',

  //   add font
  'TEMPLATE.MANAGE.MAIL.FONT.ADD.DIALOG.TITLE': '添加网页字体',
  'TEMPLATE.MANAGE.MAIL.FONT.ADD.DIALOG.CONTENT':
    '<span style="font-weight: 700">谷歌字体不被所有的邮件客户端支持，如果你使用他们</span>，你的收件人可能会看到默认字体。',
  'TEMPLATE.MANAGE.MAIL.FONT.ADD.DIALOG.CONTENT.MORE': '了解更多',
  'TEMPLATE.MANAGE.MAIL.FONT.ADD.DIALOG.CONTENT.TAB.GOOGLE': '免费字体',
  'TEMPLATE.MANAGE.MAIL.FONT.ADD.DIALOG.CONTENT.TAB.CUSTOM': '自定义字体',
  'TEMPLATE.MANAGE.MAIL.FONT.ADD.DIALOG.CONTENT.SEARCH.PHD': '搜索谷歌字体',
  'TEMPLATE.MANAGE.MAIL.FONT.ADD.DIALOG.CONTENT.SEARCH.WEB.PHD':
    '搜索自定义网页字体',
  'TEMPLATE.MANAGE.MAIL.FONT.ADD.DIALOG.CONTENT.FALLBACK.TITLE': '默认字体',
  'TEMPLATE.MANAGE.MAIL.FONT.ADD.DIALOG.CONTENT.FALLBACK.DES':
    '有些字体不被客户端支持时，默认字体将自动替换。',
  'TEMPLATE.MANAGE.MAIL.FONT.ADD.DIALOG.CONTENT.DEFAULT.SELECT.DES':
    '标题，正文，按钮，其他文本',
  'TEMPLATE.MANAGE.MAIL.FONT.ADD.DIALOG.CANCEL': '取消',
  'TEMPLATE.MANAGE.MAIL.FONT.ADD.DIALOG.CONFIRM': '增加已选字体',

  //   send-email
  'TEMPLATE.MANAGE.MAIL.TEST.EMAIL.INPUT.DES':
    '需要连续输入多个收件人时，可使用Enter、Tab键或,，|\\、分隔符号进行分隔',
  'TEMPLATE.MANAGE.TRANS.MAIL.TEST.EMAIL.INPUT.DES': '收件人',
  'TEMPLATE.MANAGE.TRANS.MAIL.TEST.EMAIL.INPUT.PHD': '输入收件人',
  'TEMPLATE.MANAGE.MAIL.TEST.EMAIL.VAR.PHD': '变量{index}',
  'TEMPLATE.SUBJECT.MAX.LENGTH.ERROR': '不能超过{length}个字符',
  'TEMPLATE.SEND.VAR.REPLACE.WITH':
    '变量 <span style="color:#00a386;font-weight: bold;">{name}</span> 替换为',
  'TEMPLATE.SEND.EMAIL.TIP': '完成“设置”下的电子邮件配置',
  'TEMPLATE.PANEL.SAVE.SUCCESS': '主题和发件人信息保存成功',
  'TEMPLATE.PANEL.SAVE.PANEL.SUCCESS': '保存成功',
  'TEMPLATE.SEND.EMAIL.DES':
    '需要连续输入多个收件人时，可使用Enter、Tab键或,，| \\ 、分隔符号进行分隔',
  'TEMPLATE.SEND.EMAIL.DOMAIN.EMPTY':
    '域名尚未添加，请联系SmartLink团队 (<a href="mailto:SmartLink_service@proximabeta.com" style="text-underline: none">SmartLink_service@proximabeta.com</a>)',
  'TEMPLATE.SEND.EMAIL.DOMAIN.TIP': '域名尚未添加，请联系SmartLink团队',
  'TEMPLATE.DOMAIN.PENDING.TIP': '待配置',

  //   list 类型
  'TEMPLATE.MANAGE.LIST.MARKET': '营销',
  'TEMPLATE.MANAGE.LIST.TRANSACTION': '事务',
  'TEMPLATE.MANAGE.LIST.TIME.TIP': '版本撤回信息',
  'TEMPLATE.MANAGE.LIST.TIME.PUB.INFO': '在{time}时间被{user}发布',
  'TEMPLATE.MANAGE.LIST.TIME.PUB.INFO.HTML':
    '在{time}<br/> <span style="color:#666666">---被{user}发布</span>',
  'TEMPLATE.MANAGE.LIST.TIME.UPDATE.INFO': '在{time}时间被{user}撤回',
  'TEMPLATE.MANAGE.LIST.TRANS.SEND.DRAFT': '发送草稿版本测试',
  'TEMPLATE.MANAGE.LIST.TRANS.SEND.PUBLISHED': '发送发布版本测试',
  'TEMPLATE.MANAGE.LIST.TRANS.PUBLISHED': '撤回发布',

  'TEMPLATE.MANAGE.TRANSACTION.PUBLIC.IMG': '发布',
  'TEMPLATE.MANAGE.TRANSACTION.DRAFT.IMG': '草稿',
  'TEMPLATE.MANAGE.TRANSACTION.NO.PUB.IMG.TIP': '没有\n' + '发布',
  'TEMPLATE.MANAGE.TRANSACTION.NO.DRAFT.IMG.TIP': '没有\n' + '保存',
  'TEMPLATE.MANAGE.TRANSACTION..DRAFT.IMG.SAME': '与已发布内容相同',
  'TEMPLATE.MANAGE.TRANSACTION.ID': '标识',
  'TEMPLATE.MANAGE.TRANSACTION.NAME': '名称',
  'TEMPLATE.MANAGE.TRANSACTION.LANG': '语种',
  'TEMPLATE.MANAGE.TRANSACTION.PHD': '资源码/联系人字段',
  'TEMPLATE.MANAGE.TRANSACTION.PUBLISH.TIME': '上次发布',

  'TEMPLATE.MANAGE.TRANSACTION.CONTENT.VERIFY': '邮件内容不能为空',

  'TEMPLATE.MANAGE.TRANSACTION.PUBLISH.SET.TITLE': '主题&发件人信息',
  'TEMPLATE.MANAGE.TRANSACTION.PUBLISH.SET.SENDER': '发件人',
  'TEMPLATE.MANAGE.TRANSACTION.PUBLISH.SET.SENDER.NAME': '选择发件人名称',
  'TEMPLATE.MANAGE.TRANSACTION.PUBLISH.SET.SENDER.ADDRESS': '发件人地址',
  'TEMPLATE.MANAGE.TRANSACTION.PUBLISH.SET.SENDER.ADDRESS.TIP':
    '选择发件人地址',
  'TEMPLATE.MANAGE.TRANSACTION.PUBLISH.SET.SENDER.SUBJECT': '主题',
  'TEMPLATE.MANAGE.TRANSACTION.PUBLISH.SET.SENDER.SUBJECT.PHD': '输入主题',
  'TEMPLATE.MANAGE.TRANSACTION.PUBLISH.SET.SENDER.PREVIEW.PHD': '输入预览文本',

  //   CLOSE
  'TEMPLATE.MANAGE.CLOSE.TEXT': '我知道了',
  'TEMPLATE.LINK.DIALOG.PLEASE.ENTER': '请输入',

  //   mjml
  'TEMPLATE.MJML.CONTENT.TAB.BLOCKS': '组件',
  'TEMPLATE.MJML.CONTENT.TAB.SECTIONS': '单元',
  'TEMPLATE.MJML.CONTENT.TAB.SECTIONS.TIP': '文本&图片',
  'TEMPLATE.MJML.CONTENT.COLOR.PICKER.HEX.TIP': 'Hex',
  'TEMPLATE.MJML.CONTENT.COLOR.PICKER.CANCEL.TIP': '取消',
  'TEMPLATE.MJML.CONTENT.COLOR.PICKER.CONFIRM.TIP': '确认',
  'TEMPLATE.MJML.CONTENT.COLOR.PICKER.GRAD.VAL': '渐变',
  'TEMPLATE.MJML.CONTENT.COLOR.PICKER.SOLID.VAL': '单色',
  'TEMPLATE.MJML.CONTENT.COLOR.PICKER.GRAD.HISTORY': '最近使用颜色',
  'TEMPLATE.MJML.CONTENT.COLOR.PICKER.GRAD.SYSTEM': '系统预设颜色',

  // html 提示
  'TEMPLATE.MANAGE.TEMPLATE.UPLOAD.HTML.DETECT': '检测结果和建议',
  'TEMPLATE.MANAGE.TEMPLATE.HTML.DETECT.TITLE': '检测结果和建议',
  'TEMPLATE.MANAGE.TEMPLATE.HTML.DETECT.SUBTITLE':
    '以下内容可能会增加电子邮件被归类为 Gmail 促销的风险。',
  'TEMPLATE.MANAGE.TEMPLATE.HTML.DETECT.TAG': '标签',
  'TEMPLATE.MANAGE.TEMPLATE.HTML.DETECT.TAG.TIP': '少于116，看起来不错',
  'TEMPLATE.MANAGE.TEMPLATE.HTML.DETECT.TAG.WARN.TIP':
    '大于116，建议减低到116以下',
  'TEMPLATE.MANAGE.TEMPLATE.HTML.DETECT.TEXT.RADIO': '文字内容比例',
  'TEMPLATE.MANAGE.TEMPLATE.HTML.DETECT.TEXT.RADIO.TIP':
    '大于7.63%，看起来不错',
  'TEMPLATE.MANAGE.TEMPLATE.HTML.DETECT.TEXT.RADIO.WARN.TIP':
    '低于7.63%，建议提升到7.63%以上',
  'TEMPLATE.MANAGE.TEMPLATE.HTML.DETECT.CODE': '代码长度',
  'TEMPLATE.MANAGE.TEMPLATE.HTML.DETECT.CODE.TIP': '少于28685，看起来不错',
  'TEMPLATE.MANAGE.TEMPLATE.HTML.DETECT.CODE.WARN.TIP':
    '大于28685，建议减低到28685以下',
  'TEMPLATE.MANAGE.TEMPLATE.HTML.DETECT.CANCEL.TIP': '取消',
  'TEMPLATE.MANAGE.TEMPLATE.HTML.DETECT.CONFIRM.TIP': '知道了，继续创作',

  // 创建 模板
  'TEMPLATE.CREATE.BASIC': '使用基础版式',
  'TEMPLATE.CREATE.BASIC.01': '基础版式01',
  'TEMPLATE.CREATE.BASIC.02': '基础版式02',
  'TEMPLATE.CREATE.BASIC.03': '基础版式03',
  'TEMPLATE.CREATE.HISTORY': '使用已保存的模板',
  'TEMPLATE.CREATE.HTML': '导入已有模板',
  'TEMPLATE.CREATE.BASIC.TITLE': '基础',
  'TEMPLATE.CREATE.BASIC.CONTENT.APPLY': '应用',
  'TEMPLATE.CREATE.BASIC.CONTENT.EMPTY': '没有模板',
  'TEMPLATE.CREATE.LANG.PHD': '所有',
  'TEMPLATE.CREATE.LANG.PREFIX.PHD': '语言',
  'TEMPLATE.CREATE.FOLDER.PHD': '所有',
  'TEMPLATE.CREATE.BASIC.CONTENT.DES': '空白模板',
  'TEMPLATE.CREATE.BASIC.LAYOUT.BLANK': '空白模板',
  'TEMPLATE.CREATE.BASIC.LAYOUT.1_2_COLUMN': '1-2 列布局',
  'TEMPLATE.CREATE.BASIC.LAYOUT.1_2_1_COLUMN': '1-2-1 列布局',
  'TEMPLATE.CREATE.BASIC.LAYOUT.1_3_COLUMN': '1-3 列布局',
  'TEMPLATE.CREATE.BASIC.LAYOUT.1_3_2_COLUMN': '1-3-2 列布局',
  'TEMPLATE.CREATE.BASIC.LAYOUT.ALTERNATE': '交替布局',

  'TEMPLATE.CREATE.HTML.TIP.1': '导入HTML文件。文件需要使用UTF-8编码',
  'TEMPLATE.CREATE.HTML.TIP.2':
    '为确保兼容性，请参考 <a href="{url}" style="color: #00a386;text-decoration: none;" target="_blank">HTML模板制作指引</a>来制作您的邮件模板。',
  'TEMPLATE.CREATE.HTML.DES': 'Import HTML',

  // 接入指引 - 营销型邮件模板
  'TEMPLATE.MARKETING.DRAWER.TITLE': '营销型邮件模板说明',
  'TEMPLATE.MARKETING.DRAWER.CONTENT.TITLE.1': '模板创建',
  'TEMPLATE.MARKETING.DRAWER.CONTENT.DESCRIPTION.1':
    '<li>模板创建可使用基础版式或已创建的版式，或直接导入HTML。</li><li>保证模板内容的可控性，同一模板，同一时间内只允许一个人编辑</li><li>在模板内添加链接可直接选择 取消订阅、更新偏好、浏览器中打开邮件的内置链接。</li>',
  'TEMPLATE.MARKETING.DRAWER.CONTENT.TITLE.2': '模板使用',
  'TEMPLATE.MARKETING.DRAWER.CONTENT.DESCRIPTION.2':
    '<li>常规活动、周期活动、AB测试都可以直接引用营销型邮件模板。</li><li>用户旅程中的发送邮件也可引用此处创建的营销型邮件模板。</li>',

  'TEMPLATE.CREATE.HTML.TIP.3':
    '可在模板中插入联系人字段或资源码。  可插入的联系人字段为：',

  'TEMPLATE.CREATE.HTML.TIP.4':
    '（1）字段作为个人信息插入到邮件模板或主题中，字段名称只能由英文字母、数字、下划线组成。',

  'TEMPLATE.CREATE.HTML.TIP.5':
    '（2）联系人字段名称和字段值为一对一关系，偏好、选项类型字段不支持插入。其他命名符合要求的联系人字段均可插入。',

  'TEMPLATE.TRANS.DRAWER.TITLE': '事务型邮件模板说明',
  'TEMPLATE.TRANS.DRAWER.LABEL':
    '当您需要向您的联系人发送事务型电子邮件，可以使用SmartLink提供的 <a href="{url}" style="color: #00a386;text-decoration: none;" target="_blank">delivery API</a> 从网站和应用程序发送事务电子邮件。',
  'TEMPLATE.TRANS.DRAWER.LABEL.2': '接入流程',
  'TEMPLATE.TRANS.DRAWER.CONTENT.TITLE.1': 'Step 1: 配置发件人域名',
  'TEMPLATE.TRANS.DRAWER.CONTENT.DESCRIPTION.1':
    '为确保事务型邮件（Transactional Email）与营销邮件（Marketing Email）独立运作，请联系 SmartLink 运营人员（或发送邮件至 <a href="mailto:SmartLink_service@proximabeta.com style="color: #00a386;text-decoration: none;" target="_blank"">SmartLink_service@proximabeta.com</a>）完成发送域的配置。',
  'TEMPLATE.TRANS.DRAWER.CONTENT.TITLE.2': 'Step 2: 编辑邮件内容',
  'TEMPLATE.TRANS.DRAWER.CONTENT.DESCRIPTION.2':
    '在此页面创建并测试邮件模板。具体操作请参考 <a href="{url}" style="color: #00a386;text-decoration: none;" target="_blank">创建事务型邮件内容 | SmartLink</a>',
  'TEMPLATE.TRANS.DRAWER.CONTENT.TITLE.3': 'Step 3: 调试邮件发送',
  'TEMPLATE.TRANS.DRAWER.CONTENT.DESCRIPTION.3':
    '获取专用 API Key（通过 SmartLink 运营人员或邮件联系 <a href="mailto:SmartLink_service@proximabeta.com style="color: #00a386;text-decoration: none;" target="_blank"">SmartLink_service@proximabeta.com</a>）。注意：SmartLink > Setting 中的 API Key 不适用于事务型邮件。详细调试流程请参考 开发者文档：<a href="{url}" style="color: #00a386;text-decoration: none;" target="_blank">发送事务型邮件 | SmartLink</a>',
  'TEMPLATE.TRANS.DRAWER.CONTENT.TITLE.4': 'Step 4: 查询发送状态',
  'TEMPLATE.TRANS.DRAWER.CONTENT.DESCRIPTION.4':
    'SmartLink 支持查询每个事务型邮件发送请求的投递状态。具体说明请参见 <a href="{url}" style="color: #00a386;text-decoration: none;" target="_blank">查询已发送邮件的状态 | SmartLink</a>',

  'TEMPLATE.TRANS.DRAWER.REMINDER.TITLE': '注意',
  'TEMPLATE.TRANS.DRAWER.REMINDER.1':
    'transactional email的发送域需区别于您的marketing email域名，以实现域名信誉度隔离',
  'TEMPLATE.TRANS.DRAWER.REMINDER.2':
    '单业务默认单日最高发送事务型邮件限额为150万封，QPS（Queries Per Second）为200',
  'TEMPLATE.TRANS.DRAWER.REMINDER.3':
    '使用事务型邮件接口前，或需提高发送限额，请提前3个工作日联系 SmartLink 运营人员或邮件联系 <a href="mailto:SmartLink_service@proximabeta.com style="color: #00a386;text-decoration: none;" target="_blank"">SmartLink_service@proximabeta.com</a>',
  // 营销模板
  'TEMPLATE.MARKETING.BASELINE.LANG.NOTIFICATION': '请先选择模板语言',
  'TEMPLATE.MARKETING.LANG.LABEL': '启用多语言',
  'TEMPLATE.MARKETING.LANG.TITLE': '选择其他语言',
  'TEMPLATE.MARKETING.LANG.PLACEHOLDER': '选择语言',
  'TEMPLATE.MARKETING.LANG.SEARCH': '搜索语言',
  'TEMPLATE.MARKETING.FILE.EXPORT.TITLE': '导出文本内容',
  'TEMPLATE.MARKETING.FILE.EXPORT': '下载多语言模板CSV文件',
  'TEMPLATE.MARKETING.FILE.EXPORT.TOTAST': '请先选择多语言',
  'TEMPLATE.MARKETING.FILE.EXPORT.TIPS': '提示：只有文本和按钮的内容会被导出',
  'TEMPLATE.MARKETING.FILE.UPLOAD.TITLE': '上传多语言模板CSV文件',
  'TEMPLATE.MARKETING.FILE.UPLOAD.GUIDE': '点击或拖拽CSV文件',
  'TEMPLATE.MARKETING.FILE.UPLOAD.TIPS.1': '1.仅支持UTF-8格式的CSV',
  'TEMPLATE.MARKETING.FILE.UPLOAD.TIPS.2': '2.文件大小不大于{size}MB',
  'TEMPLATE.MARKETING.FILE.UPLOAD.TIPS.3': '3.资源码在任何语言中保持一致',
  'TEMPLATE.MARKETING.FILE.UPLOAD.TIPS.4':
    '4.所有其他语言的文本将与初始语言的文本格式相同（基于第一个字符）',
  'TEMPLATE.MARKETING.UPLOAD.FILED.TITLE': '上传错误',
  'TEMPLATE.MARKETING.FILE.ERROR.OVER.MAX.SIZE':
    '仅支持csv格式，文件大小限制在{num}MB以内',
  'TEMPLATE.MARKETING.FILE.ERROR.TIME.OUT': '文件上传超时',
  'TEMPLATE.MARKETING.FILE.ERROR.TYPE': '文件格式错误',
  'TEMPLATE.MARKETING.FILE.ERROR.HEADER.LANG.ERROR': '语言信息和下载文件不匹配',
  'TEMPLATE.MARKETING.FILE.ERROR.LINE.HEADER.ERROR': '首列信息和下载文件不匹配',
  'TEMPLATE.MARKETING.FILE.ERROR.PLACEHOLDER.ERROR': '数据错误-资源码不匹配',
  'TEMPLATE.MARKETING.ERROR.PLACEHOLDER.ERROR': '资源码不匹配',
  'TEMPLATE.MARKETING.FILE.UPLOAD.SUCCESS.STATISTICAL':
    '<span class="color-666"><b class="font-size-16 color-333">{langNum}种语言</b><b class="font-size-16 color-333">{rowNum}个内容</b>已经被上传</span>',
  'TEMPLATE.MARKETING.SETTING.SAVE': '设置保存成功',

  //   保存提示form
  'TEMPLATE.MARKETING.SETTING.FORM.SAVE': '请在表单组件设置中选择表单',
  //   测试邮件
  'TEMPLATE.MARKETING.TEST.EMAIL.FORM.TIP1':
    '*若模板中包含表单，只有在满足以下两个条件时，表单提交的数据才会在 SmartLink 中更新：',
  'TEMPLATE.MARKETING.TEST.EMAIL.FORM.TIP2': '· 表单已激活；',
  'TEMPLATE.MARKETING.TEST.EMAIL.FORM.TIP3':
    '· 提交者的邮箱在当前项目中是已存在的联系人。',
  'TEMPLATE.MARKETING.TEST.EMAIL.CONFIRM.TXT': '不更新，直接发送',
  'TEMPLATE.MARKETING.TEST.EMAIL.SUBJECT.HEADER': '主题已更新',
  'TEMPLATE.MARKETING.TEST.EMAIL.SUBJECT.DES':
    '请选择是否更新测试邮件主题到模板上',
  'TEMPLATE.MARKETING.TEST.EMAIL.SUBJECT.BASELINE': '模板主题和预览文本',
  'TEMPLATE.MARKETING.TEST.EMAIL.SUBJECT.CONTRAST': '测试邮件主题和预览文本',
  'TEMPLATE.MARKETING.TEST.EMAIL.CONFIRM.UPDATE.TXT': '确认更新',

  //   subject 检测提示
  'TEMPLATE.MARKETING.TEST.EMAIL.SUBJECT.DETECT.SENSITIVE.PREFIX':
    '标题中包含的',
  'TEMPLATE.MARKETING.TEST.EMAIL.SUBJECT.DETECT.SENSITIVE.WORD': '{content}',
  'TEMPLATE.MARKETING.TEST.EMAIL.SUBJECT.DETECT.SENSITIVE.WORD.TIP1':
    'Gmail、Outlook 等邮件服务商通常会对标题进行审核，并将含有广告嫌疑的邮件归类到“推广”或“垃圾邮件”文件夹。为此我们提供有针对性的敏感词检测功能，帮助你提升邮件送达率。想了解更多？',
  'TEMPLATE.MARKETING.TEST.EMAIL.SUBJECT.DETECT.SENSITIVE.WORD.TIP2':
    '点击查看完整指南。',
  'TEMPLATE.MARKETING.TEST.EMAIL.SUBJECT.DETECT.SENSITIVE.SUFFIX':
    '是敏感词，可能影响投递成功率，建议修改为其他词。',
  'TEMPLATE.ADD.VARIABLE.DIALOG.HEADER': '选择联系人字段',
  'TEMPLATE.ADD.VARIABLE.DIALOG.CONTACT.LABEL': '您想插入那个联系人字段',
  'TEMPLATE.ADD.VARIABLE.DIALOG.CONTACT.LABEL.DES':
    '邮件发送后，会使用系统内联系人信息替换',
  'TEMPLATE.ADD.VARIABLE.DIALOG.CONTACT.TOOLTIP':
    '如需插入，字段名称只能由英文字母、数字、下划线组成，请先到字段设置中修改字段名称',
  'TEMPLATE.ADD.VARIABLE.DIALOG.DEFAULT.VALUE.LABEL':
    '如果字段为空，应该使用那个值？',
  'TEMPLATE.ADD.VARIABLE.DIALOG.OPTION.TOOLTIP':
    '字段作为个人信息插入到邮件模板或主题中，字段名称只能由英文字母、数字、下划线组成。如需插入需修改名称。',
  'TEMPLATE.ADD.VARIABLE.DIALOG.CONTACT.ERROR':
    '<span title="">字段作为个人信息插入到邮件模板或主题中，字段名称只能由英文字母、数字、下划线组成。如需插入需<a href="{href}" target="_blank">修改字段名称</a></span>',
  'TEMPLATE.ADD.VARIABLE.DIALOG.CONTACT.WHATSAPP.ERROR':
    '<span title="">字段作为个人信息插入，字段名称只能由英文字母、数字、下划线组成。如需插入需<a href="{href}" target="_blank">修改字段名称</a></span>',
  'TEMPLATE.ADD.VARIABLE.DIALOG.DEFAULT.VALUE.ERROR': '默认值不能为空',
  'TEMPLATE.MANAGE.ADD.Subject.PREVIEW.TEXT': '主题',
  'TEMPLATE.MANAGE.ADD.Subject.PREVIEW.TEXT.TOOLTIP':
    '在这里设置模板主题和预览文本',

  // 多语言模板对比弹窗文案
  'TEMPLATE.MAIL.COMPARE.TITLE': '提示:请确认是否修改了活动主题',
  'TEMPLATE.MAIL.COMPARE.BASELINE.TITLE': '模板主题',
  'TEMPLATE.MAIL.COMPARE.CONTRAST.TITLE': '活动主题',
};
